import { ListData } from "../types/List";
import { TrackerData, TrackerRecordData } from "../types/Patient";
import { WorkflowData } from "../types/Workflow";
import { workflowApiUrl } from "./api";

const API_URL = "/Workflows";
const TRACKER_URL = "/Trackers";

export const getData = async (id: number): Promise<WorkflowData[]> => {
  try {
    const res = await workflowApiUrl.get<WorkflowData[]>(
      `${API_URL}/get-workflows`,
      {
        params: {
          id: id,
        },
      }
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all workflows error: ${
        error.response?.data?.message || error.message
      }`
    );
    return [];
  }
};

export const getDataById = async (id: number): Promise<WorkflowData | null> => {
  try {
    const res = await workflowApiUrl.get<WorkflowData>(`${API_URL}/${id}`);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get workflow error: ${error.response?.data?.message || error.message}`
    );
    return null;
  }
};

export const createData = async (
  user: Partial<WorkflowData>
): Promise<WorkflowData | null> => {
  try {
    const res = await workflowApiUrl.post<WorkflowData>(API_URL, user);
    return res.data;
  } catch (error: any) {
    console.error(
      `Create workflow error: ${error.response?.data?.message || error.message}`
    );
    return null;
  }
};

export const updateData = async (
  id: number,
  user: Partial<WorkflowData>
): Promise<WorkflowData | null> => {
  try {
    const res = await workflowApiUrl.put<WorkflowData>(
      `${API_URL}/${id}`,
      user
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Update workflow error: ${error.response?.data?.message || error.message}`
    );
    return null;
  }
};

export const moveUp = async (
  data: Partial<WorkflowData>
): Promise<WorkflowData | null> => {
  try {
    const res = await workflowApiUrl.post<WorkflowData>(
      `${API_URL}/move-up`,
      data
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Move up record error: ${error.response?.data?.message || error.message}`
    );
    return null;
  }
};

export const deleteData = async (id: number): Promise<boolean> => {
  try {
    await workflowApiUrl.delete(`${API_URL}/${id}`);
    return true;
  } catch (error: any) {
    console.error(
      `Delete person error: ${error.response?.data?.message || error.message}`
    );
    return false;
  }
};

export const getWorkflowData = async (id: number): Promise<ListData[]> => {
  try {
    const res = await workflowApiUrl.get<ListData[]>(
      `${API_URL}/get-workflows?`,
      { params: { id: id } }
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Get workflows error: ${error.response?.data?.message || error.message}`
    );
    return [];
  }
};

export const registerPatient = async (
  data: Partial<TrackerData>
): Promise<TrackerData | null> => {
  try {
    const res = await workflowApiUrl.post<TrackerData>(TRACKER_URL, data);
    return res.data;
  } catch (error: any) {
    console.error(
      `Register patient error: ${
        error.response?.data?.message || error.message
      }`
    );
    return null;
  }
};

export const getRegisteredRecords = async (
  id: Partial<number>
): Promise<TrackerRecordData[]> => {
  try {
    const res = await workflowApiUrl.get<TrackerRecordData[]>(
      `${TRACKER_URL}/registered-ids`,
      {
        params: {
          id: id,
        },
      }
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Get registered Ids error: ${
        error.response?.data?.message || error.message
      }`
    );
    return [];
  }
};

export const getPendingTaskIds = async (
  transactionid: Partial<number>
): Promise<number[]> => {
  try {
    const res = await workflowApiUrl.get<number[]>(
      `${TRACKER_URL}/pending-tasks`,
      {
        params: {
          id: transactionid,
        },
      }
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Get pending task Ids error: ${
        error.response?.data?.message || error.message
      }`
    );
    return [];
  }
};
